import styled from 'styled-components'

const LabelStyled = styled.div<{ $disabled?: boolean }>`
  max-width: 100%;
  flex-grow: 1;
  padding: 0 8px;
  word-break: break-word;
  overflow: hidden;
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
`

export default LabelStyled
